import React from "react";

function Store() {

    return (
      <svg aria-hidden="true" focusable="false" data-prefix="fad" data-icon="store-alt" className="svg-inline--fa fa-store-alt fa-w-20" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><g className="fa-group"><path className="fa-secondary" fill="currentColor" d="M320 384H128V224H64v256a32 32 0 0 0 32 32h256a32 32 0 0 0 32-32V224h-64zm192-160v272a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V224z" opacity="0.4"></path><path className="fa-primary" fill="currentColor" d="M634.55 142.2c14.1 21.3-1.1 49.8-26.6 49.8H32.05c-25.6 0-40.8-28.5-26.6-49.8l85.3-128A31.87 31.87 0 0 1 117.35 0h405.2a32.18 32.18 0 0 1 26.7 14.2z"></path></g></svg>
    );
  }

export default Store;